<template>
  <svg viewBox="0 0 240 200" width="100%" color="#b38637" fill="none" aria-hidden="true" focusable="false">
    <ellipse cx="122" cy="178" rx="79" ry="10" fill="currentColor" opacity=".1" />
    <g transform="rotate(-14 89 99)">
      <rect x="35" y="29" width="105" height="145" rx="12" fill="#382a0c" stroke="#b38637" stroke-width="2" />
      <rect x="43" y="37" width="89" height="129" rx="7" stroke="#e7c675" stroke-opacity=".5" />
      <path d="m68 77 10 8 11-20 11 20 10-8-6 29H74l-6-29Z" fill="#e7c675" />
      <path d="M78 113h23" stroke="#e7c675" stroke-width="3" stroke-linecap="round" />
      <circle cx="89" cy="136" r="6" fill="#e7c675" />
      <path d="M76 151c0-8 26-8 26 0" stroke="#e7c675" stroke-width="3" stroke-linecap="round" />
    </g>
    <g transform="rotate(10 155 104)">
      <rect x="99" y="35" width="108" height="145" rx="12" fill="#e7c675" stroke="#b38637" stroke-width="2" />
      <rect x="107" y="43" width="92" height="129" rx="7" stroke="#825411" stroke-opacity=".5" />
      <path d="m129 80 11 8 13-22 13 22 11-8-6 31h-36l-6-31Z" fill="#382a0c" />
      <path d="M140 119h26" stroke="#382a0c" stroke-width="3" stroke-linecap="round" />
      <path
        d="M151 149c-5-7-9-9-13-9a8 8 0 0 0 0 16c8 0 13-16 21-16a8 8 0 0 1 0 16c-4 0-8-2-13-9"
        stroke="#382a0c"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path d="m113 45 82 82v-15l-69-69h-11Z" fill="white" opacity=".18" />
    </g>
    <path d="m207 15 3 9 9 3-9 3-3 9-3-9-9-3 9-3 3-9ZM29 102l2 7 7 2-7 2-2 7-2-7-7-2 7-2 2-7Z" fill="currentColor" />
    <circle cx="53" cy="18" r="3" fill="currentColor" opacity=".6" />
    <circle cx="220" cy="137" r="3" fill="currentColor" opacity=".6" />
  </svg>
</template>
